export default function (to) {
  const tag = getTag()
  const href = getLink(to)
  tag.setAttribute('href', href)
}

function getLink(to) {
  let path
  if(typeof to.meta.canonical === 'function') {
    path = to.meta.canonical(to)
  } else {
    path = to.path
  }

  return window.location.origin + path
}

function getTag() {
  return document.head.querySelector('link[rel="canonical"]') ||
    createAndAppendTag()
}

function createAndAppendTag() {
  const tag = document.createElement('link')
  tag.setAttribute('rel', 'canonical')
  document.head.appendChild(tag)
  return tag
}

export function removeCanonicalTag() {
  const tag = document.head.querySelector('link[rel="canonical"]')
  if (tag) {
    document.head.removeChild(tag)
  }
}
